import type { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import { useAuthStore } from '@/stores/auth/store'
import { useMaintenanceStore } from '@/stores/maintenance/store'
import { isUnauthorizedError, isUnknownUserError } from '../errors'
import { storage } from '@/utils/storage/storage'

function addHeaders(request: AxiosRequestConfig, headers: Record<string, any>) {
  request.headers = {
    ...request.headers,
    ...headers,
  }

  return request
}

function removeEndingSlash(request: AxiosRequestConfig) {
  if (request.url?.endsWith('/')) {
    request.url = request.url.slice(0, -1)
  }

  return request
}

async function addAuthHeader(request: AxiosRequestConfig) {
  const authToken = storage.easybellDeAuth

  if (authToken) {
    request = addHeaders(request, {
      Authorization: `Bearer ${authToken}`,
    })
  }

  return request
}

export async function requestInterceptor(
  request: AxiosRequestConfig
): Promise<any> {
  request = removeEndingSlash(request)

  request = await addAuthHeader(request)

  request = addHeaders(request, {
    'Cache-Control': 'no-cache',
  })

  return request
}

export function responseInterceptor(response: AxiosResponse) {
  return response
}

export function errorInterceptor(error: AxiosError<unknown>) {
  const isNavigationEndpoint = error.config?.url?.includes('/api/navigation')
  const isWhoamiEndpoint = error.config?.url?.includes('/whoami')

  if (error.response?.status === 503) {
    useMaintenanceStore().loadMaintenanceStatus()
  }

  if (isUnknownUserError(error) && isWhoamiEndpoint) {
    useAuthStore().goToMyEasybell()
  } else if (isUnauthorizedError(error) && !isNavigationEndpoint) {
    useAuthStore().goToLogin()
  }

  return Promise.reject(error)
}
